import React from 'react'
import { formatDistanceToNow, parseISO } from 'date-fns'
import type { YoutubeContent } from './types'

import { trimLongWords } from './utils/trimLongWords'

export const VideoCard: React.FC<{ content: YoutubeContent }> = ({ content }) => {
  let formattedDate = ''
  try {
    const date = parseISO(content.snippet.publishedAt)
    formattedDate = formatDistanceToNow(date, { addSuffix: true }).replaceAll('about ', '')
  } catch (e) {
    console.log({ e })
  }

  const parser = new DOMParser()
  const parsedTitle = parser.parseFromString(content.snippet.title, 'text/html').body.textContent
  const trimmedTitle = parsedTitle ? trimLongWords(parsedTitle, 50, 50) : ''

  return (
    <div className="bg-white p-2 rounded-md shadow-md" key={'a-content.id' + content.id}>
      <a href={'https://www.youtube.com/watch?v=' + content.id} target="_blank" rel="noreferrer">
        <img className="w-full h-24 object-cover mb-4" src={content.snippet.thumbnails.high.url} />
      </a>
      <div className="text mb-2">
        <a
          href={'https://www.youtube.com/watch?v=' + content.id}
          target="_blank"
          className="text-gray-800 hover:text-blue-800 hover:underline text-sm  leading-tight grid"
          style={{ lineHeight: '1rem' }}
          rel="noreferrer"
        >
          {trimmedTitle}
        </a>
      </div>
      <div className="mt-1 text-xs">
        <span className="text-gray-900">{formattedDate}</span> at{' '}
        <a
          href={`https://www.youtube.com/channel/${content.snippet.channelId}/videos`}
          className="text-gray-800 hover:text-blue-800 hover:underline text-xs"
          target="_blank"
          rel="noreferrer"
        >
          {content.snippet.channelTitle}
        </a>
      </div>
    </div>
  )
}
